module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('Checkbox', {
    attrs: {
      "inputId": "irdActive",
      "binary": true,
      "trueValue": true,
      "falseValue": false
    },
    model: {
      value: (_vm.irdActive),
      callback: function($$v) {
        _vm.irdActive = $$v
      },
      expression: "irdActive"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "p-ml-2",
    attrs: {
      "for": "irdActive"
    }
  }, [_vm._v("IRD Active")])], 1), _vm._v(" "), (_vm.irdActive) ? _c('div', {
    staticClass: "p-col-12"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "irdUsername"
    }
  }, [_vm._v("IRD Username")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "irdUsername",
      "placeholder": "Enter IRD username",
      "required": ""
    },
    model: {
      value: (_vm.irdUsername),
      callback: function($$v) {
        _vm.irdUsername = $$v
      },
      expression: "irdUsername"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "irdPassword"
    }
  }, [_vm._v("IRD Password")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "irdPassword",
      "placeholder": "Enter IRD password",
      "required": ""
    },
    model: {
      value: (_vm.irdPassword),
      callback: function($$v) {
        _vm.irdPassword = $$v
      },
      expression: "irdPassword"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('Button', {
    attrs: {
      "label": "Save",
      "icon": "pi pi-save",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.updateOrganisationIRD
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-342822a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/settings/IRDSetup.vue
// module id = 2134
// module chunks = 0